$(document).ready(function() {
  const tooltipIcon = document.querySelector(".variant-description-icon");
  const descriptionBox = document.querySelector(".variant-description-container");

  if (tooltipIcon) { 
    tooltipIcon.addEventListener("click", function() {
      // Toggler mellem at vise eller skjule beskrivelsen med animation
      if (descriptionBox.classList.contains("active")) {
        descriptionBox.classList.remove("active");
      } else {
        descriptionBox.classList.add("active");
      }
    });
  }

  /* Handles checkbox for terms & conditions in cart-drawer and quick-buy-drawer web-components with Shadow DOM */
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function(e) {
    // Prevent multiple alerts from the same click
    if (e.isDefaultPrevented() || $(this).data('validation-handled')) {
      return;
    }
    
    // Find the closest checkbox - either in cart-drawer or quick-buy-drawer
    const $button = $(this);
    // Search in form, drawer sections, or the entire drawer component
    const $container = $button.closest('form, .quick-buy-drawer__info, .quick-buy-drawer__variant, cart-drawer, quick-buy-drawer');
    let $checkbox = $container.find('#agree, .terms-checkbox').first();
    
    // If not found in container, search in the entire drawer (for shadow DOM)
    if (!$checkbox.length) {
      const $drawer = $button.closest('quick-buy-drawer, cart-drawer');
      if ($drawer.length) {
        $checkbox = $drawer.find('#agree, .terms-checkbox').first();
      }
    }
    
    // Check if checkbox is checked
    if (!$checkbox.length || !$checkbox.is(':checked')) {
      e.preventDefault();
      e.stopPropagation();
      $button.data('validation-handled', true);
      alert(window.translations["terms_and_conditions_error"]);
      // Reset after a short delay to allow for retry
      setTimeout(function() {
        $button.removeData('validation-handled');
      }, 100);
      return false;
    }
    // If checked, allow the form to submit naturally (button's default behavior)
  });
});

// Toggles the variant description when a variant is selected
document.addEventListener('variant:change', function(event) {
  let variant = event.detail.variant;
  let previousVariant = event.detail.previousVariant;

  $(`[data-variantid="${previousVariant.id}"]`).hide();
  $(`[data-variantid="${variant.id}"]`).show();

});
